/**
 * Structural shape of a failed API call's error object — matches `ApiError`
 * from `apiClient.ts` without importing the class itself.
 */
export interface ApiErrorLike {
  status?: number;
  payload?: { error?: string; detail?: string };
}

/**
 * Resolves a user-facing message for a failed API call. A known
 * `payload.error` machine-key maps to the caller-supplied message; an
 * unmapped code falls back to `payload.detail`, then the generic message.
 */
export const resolveApiErrorMessage = (
  error: unknown,
  codeMessages: Record<string, string>,
  genericMessage: string,
): string => {
  const err = error as ApiErrorLike;
  const code = err?.payload?.error;
  if (code && code in codeMessages) {
    return codeMessages[code];
  }
  return err?.payload?.detail ?? genericMessage;
};
